import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './RelatedProductsList.module.scss';

// Group consecutive items by product family so a family is never split across
// columns. Family = the title without its trailing generation number/variant.
const groupByFamily = (items) => {
    const groups = [];
    items.forEach((item) => {
        const family = item.replace(/\s+\d.*$/, '');
        const last = groups[groups.length - 1];
        if (last && last.family === family) last.items.push(item);
        else groups.push({ family, items: [item] });
    });
    return groups;
};

const RelatedProductsList = ({ title, items = [] }) => {
    const useColumns = items && items.length >= 6;
    const groups = groupByFamily(items);

    return (
        <div className={styles['RelatedProductsList']}>
            <div className={styles['RelatedProductsList__Container']}>
                <h2 className={styles['RelatedProductsList__Title']}>
                    {title}
                </h2>
                {items && (
                    <div
                        className={classNames(
                            styles['RelatedProductsList__List'],
                            {
                                [styles['RelatedProductsList__List--Columns']]:
                                    useColumns,
                            }
                        )}>
                        {groups.map((group, index) => (
                            <ul
                                key={index}
                                className={
                                    styles['RelatedProductsList__Group']
                                }>
                                {group.items.map((item, itemIndex) => (
                                    <li
                                        key={itemIndex}
                                        className={
                                            styles[
                                                'RelatedProductsList__ListItem'
                                            ]
                                        }>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

RelatedProductsList.propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
};

export default RelatedProductsList;
